// extracted by mini-css-extract-plugin
export var phone = "_4w-0";
export var phoneDragging = "_4w-1";